// generated from 1_005 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const conversionEventFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("conversion_event_filter"),
  comparison_key: z.enum([
    "8", // 881 (87.66%)
    "7", // 124 (12.34%)
  ]),
  display_name: z.string(),
  // undefined: 168 (16.72%), defined 837 (83.28%)
  raw_value: common.objectId.optional(),
  value: z.object({
    // true 137 (13.63%), false 868 (86.37%)
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
